// extracted by mini-css-extract-plugin
export default {"Form":"_80REqwYEqfFYKOZANE1orUWQGT-kl9MrO-8t94CBGfz","columns":"nzGS6YwHE54B9pY_NDbZdVyxAV9oLEfWChyBrBiMZ8","bad":"_2qF9gS_LDbH_JZnEraSMc0XNHjtjdtqRPl2KVxOphZY"};